var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Step } from '@shared/claim/steps';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@shared/layout/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
const claim = namespace('claim');
const qualification = namespace('qualification');
let ShouldRepairLeakage = class ShouldRepairLeakage extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/pause-parcours.svg');
    }
    async declarePersonalPropertyDamages() {
        await this.updateAndSaveClaimStep(Step.RoomDamagesOwnerInsurer);
    }
    get titleChoice() {
        return this.qualification.isPremiseFurnished
            ? this.$tc('room_damages_owner_insurer.title.furnished')
            : this.$tc('room_damages_owner_insurer.title');
    }
};
__decorate([
    claim.Action('updateAndSaveClaimStep')
], ShouldRepairLeakage.prototype, "updateAndSaveClaimStep", void 0);
__decorate([
    qualification.State('qualification')
], ShouldRepairLeakage.prototype, "qualification", void 0);
ShouldRepairLeakage = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
        },
    })
], ShouldRepairLeakage);
export default ShouldRepairLeakage;
